/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBadgeUpFilled = createReactComponent(
  "arrow-badge-up-filled",
  "IconArrowBadgeUpFilled",
  [
    [
      "path",
      {
        d: "M11.375 6.22l-5 4a1 1 0 0 0 -.375 .78v6l.006 .112a1 1 0 0 0 1.619 .669l4.375 -3.501l4.375 3.5a1 1 0 0 0 1.625 -.78v-6a1 1 0 0 0 -.375 -.78l-5 -4a1 1 0 0 0 -1.25 0z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ]
  ]
);

export { IconArrowBadgeUpFilled as default };
//# sourceMappingURL=IconArrowBadgeUpFilled.js.map
